/**
 * 账单详情里一道菜的折后单价（POS-174）。没有折扣时返回 null（不划线）。
 *
 * - 老数据 / 收银手动折扣：tempDiscountMod 是每份的加减额（负数是减），实付 = price + tempDiscountMod；
 * - 没有非 0 的 tempDiscountMod 时按 tempDiscountStr 算（和门店 PHP calc_temp_discount 同一套写法）：
 *   - "50p"（或 "50%"）是按比例减，实付 = price × (1 − 50 / 100)；
 *   - 纯数字是每份减额：快餐单 / 收银云端活动单（POS-153 D2）每行都写两位小数，没优惠是 "0.00"，实付 = price − 减额。
 *
 * 只认有限数值，减额 / 比例为 0、算出 NaN 都当没折扣，不会再出现「原价全划掉、实付显示空」。
 */
export function discountedPrice (dish) {
  if (!dish) return null
  const price = parseFloat(dish.price)
  if (!Number.isFinite(price)) return null
  const mod = parseFloat(dish.tempDiscountMod)
  if (Number.isFinite(mod) && mod !== 0) return price + mod
  const str = dish.tempDiscountStr == null ? '' : String(dish.tempDiscountStr).trim()
  const off = parseFloat(str)
  if (!Number.isFinite(off) || off <= 0) return null
  if (/[p%]$/i.test(str)) {
    if (off > 100) return null
    // 和 PHP 一样先把减额取到分（DECIMAL(10,2)，四舍五入）再从原价里扣；price × off 就是以分为单位的减额
    const cut = Math.round(Number((price * off).toPrecision(12))) / 100
    return Math.round((price - cut) * 100) / 100
  }
  return Math.max(0, price - off)
}

export function hasDiscount (dish) {
  return discountedPrice(dish) !== null
}
